import { apiClient } from "../config";

async function restorePerson(personId: any) {
  const res = await apiClient.put(`/admin/users/restore/${personId}`);
  return res.data;
}

export default restorePerson;
